import axios from 'axios'
import showToastify from '../utils/toastify'
import 'toastify-js/src/toastify.css'
import { find } from 'utils/dom'

export default function denunciaForm() {
    const page = find("[js-page='denuncia']");
    if (!page) return;

    const btnSubmit = document.querySelector('.denuncia-form-1 button[type=submit]');
    const denunciaFormSubmit = document.querySelector('.denuncia-form-1');

    function disabledBtn() {
        btnSubmit.disabled = true;
        btnSubmit.classList.add('disabled');
    }

    function enabledBtn() {
        btnSubmit.disabled = false;
        btnSubmit.classList.remove('disabled');
    }

    function showMessage(response) {
        const message = response.data ? response.data.message : response.message;
        showToastify(message);
        denunciaFormSubmit.reset();
        setTimeout(enabledBtn, 1000);
    }

    if (denunciaFormSubmit) {
        denunciaFormSubmit.addEventListener('submit', async function (event) {
            event.preventDefault();
            disabledBtn();

            if (!window.grecaptcha || !window.site_key) {
                console.error('reCAPTCHA não carregado ou site_key ausente.');
                enabledBtn();
                return;
            }

            try {
                const token = await grecaptcha.execute(window.site_key, { action: 'submit' });

                const formData = new FormData();
                formData.append('mensagem', document.querySelector('.denuncia-form-1 .form-group textarea[name=mensagem]').value);
                formData.append('recaptcha_token', token);

                const url = '/denuncia/';

                axios
                    .post(url, formData)
                    .then((response) => showMessage(response))
                    .catch((response) => showMessage(response));
            } catch (err) {
                console.error('Erro ao gerar token reCAPTCHA:', err);
                enabledBtn();
                showToastify('Erro de segurança ao enviar. Tente novamente.');
            }
        });
    }
}
